import React, {useEffect, useState} from 'react';
import { useFormik } from 'formik';
import {Box, FormControlLabel, Grid, MenuItem, Switch, TableCell, TextField} from "@material-ui/core";
import {Values} from "Tools/Values";
import {Person, State} from "@src/Interfaces/Entity/Person";
import * as Yup from "yup";
import {FullWidthTextField, ShowLabel} from "@src/Shared/styles";

const validationSchema = (uniquenessValidator: (fieldName: string) => any, phoneValidator: () => any) => {
    return Yup.object().shape({
        name: Yup.string().required(() => { return Values.getLocalizationValue("fieldRequired"); })
            // .special(() => Values.getLocalizationValue("fieldSpecial"))
            .test("isNameExists", Values.getLocalizationValue("nameAlreadyExists"), uniquenessValidator("name")),
        fullName: Yup.string().required(() => { return Values.getLocalizationValue("fieldRequired"); }),
        email: Yup.string()
            .required(() => {
                return Values.getLocalizationValue("fieldRequired");
            })
            .email(() => {
                return Values.getLocalizationValue("invalidEmail");
            })
            .test(
                "isEmailExists",
                Values.getLocalizationValue("emailAlreadyExists"),
                uniquenessValidator("email")
            ),
        organisation: Yup.string().required(() => {
            return Values.getLocalizationValue("fieldRequired");
        }),
        phoneNumber: Yup.string()
            .test(
                "isPhoneValid",
                Values.getLocalizationValue("invalidPhoneNumber"),
                phoneValidator()
            )
    });
}

interface IPersonDialogDataForm {
    personId?: string;
    setRef: (ref: any) => void;
    onSubmit: (data: any) => void;
    isDisabled?: boolean;
    activeOrganisations: any;
    persons: Array<Person>;
    uniquenessValidator: (fieldName: string) => any;
    phoneValidator: () => any;
    initialValues: any;
}

export const PersonDialogDataForm = (props: IPersonDialogDataForm) => {
    const [showPassword, setShowPassword] = useState(false);

    const formik = useFormik({
        initialValues: {
            name: '',
            fullName: '',
            email: '',
            phoneNumber: '',
            organisation: '',
            isActive: true,
        },
        onSubmit: (data) => {
            props.onSubmit(data);
        },
        validationSchema: validationSchema(props.uniquenessValidator, props.phoneValidator),
        validateOnChange: false,
        validateOnBlur: false
    });

    useEffect(() => {
        if (props.initialValues) {
            formik.setValues( { ...props.initialValues } );
            formik.setFieldValue("isActive", props.initialValues.state == State.Active);
        }
    }, [props.initialValues]);


    return (
        <form onSubmit={formik.handleSubmit} ref={ref => props.setRef(ref)}>
            <Grid container spacing={2} direction={"column"}>
                { props.initialValues && (
                    <Grid item>
                        <FullWidthTextField
                            disabled
                            name={"id"}
                            readonly={true}
                            size={"small"}
                            label={Values.getLocalizationValue("id")}
                            variant="outlined"
                            value={props.initialValues.id}
                        />
                    </Grid>
                )}
                <Grid item>
                    <FullWidthTextField
                        name={"name"}
                        onChange={formik.handleChange}
                        value={formik.values.name}
                        disabled={props.isDisabled}
                        size={"small"}
                        error={formik.errors.name}
                        helperText={formik.errors.name}
                        label={Values.getLocalizationValue("username")}
                        variant="outlined"
                    />
                </Grid>
                <Grid item>
                    <FullWidthTextField
                        name={"fullName"}
                        onChange={formik.handleChange}
                        value={formik.values.fullName}
                        disabled={props.isDisabled}
                        size={"small"}
                        error={formik.errors.fullName}
                        helperText={formik.errors.fullName}
                        label={Values.getLocalizationValue("fullName")}
                        variant="outlined"
                    />
                </Grid>
                <Grid item>
                    <FullWidthTextField
                        name={"email"}
                        onChange={formik.handleChange}
                        value={formik.values.email}
                        disabled={props.isDisabled}
                        size={"small"}
                        error={formik.errors.email}
                        helperText={formik.errors.email}
                        label={Values.getLocalizationValue("email")}
                        variant="outlined"
                    />
                </Grid>
                <Grid item>
                    <FullWidthTextField
                        name={"phoneNumber"}
                        onChange={formik.handleChange}
                        value={formik.values.phoneNumber}
                        disabled={props.isDisabled}
                        size={"small"}
                        error={formik.errors.phoneNumber}
                        helperText={formik.errors.phoneNumber}
                        label={Values.getLocalizationValue("phoneNumber")}
                        variant="outlined"
                    />
                </Grid>
                <Grid item>
                    <FullWidthTextField
                        select
                        name={"organisation"}
                        onChange={formik.handleChange}
                        value={formik.values.organisation}
                        disabled={props.isDisabled}
                        size={"small"}
                        error={formik.errors.organisation}
                        helperText={formik.errors.organisation}
                        label={Values.getLocalizationValue("organisation")}
                        variant="outlined"
                    >
                        { props.activeOrganisations?.map((org: any, i: number) => <MenuItem key={i} value={org.id}>{org.name}</MenuItem>)}
                    </FullWidthTextField>
                </Grid>
                <Grid item>
                    <Box pl={2}>
                        <FormControlLabel
                            label="Is active"
                            control={
                                <Switch
                                    color={"primary"}
                                    name={"isActive"}
                                    disabled={props.isDisabled}
                                    onChange={formik.handleChange}
                                    checked={formik.values.isActive}
                                />
                            }
                        />
                    </Box>
                </Grid>
            </Grid>
        </form>
    )
}